export default "__VITE_ASSET__CDV0m0kV__"